// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { webviHost16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-webvi-host': IconWebviHost;
    }
}

/**
 * The icon component for the 'webviHost' icon
 */
export class IconWebviHost extends Icon {
    public constructor() {
        super(webviHost16X16);
    }
}

registerIcon('icon-webvi-host', IconWebviHost);
export const iconWebviHostTag = 'nimble-icon-webvi-host';
